export class ThreadId {
    constructor({ address, type }) {
        this.address = address;
        this.type = type;
    }
    equals(other) {
        return this.address == other.address && this.type === other.type;
    }
    toString() {
        return this.type
            ? this.type.toString() + ':' + this.address.toString()
            : this.address.toString();
    }
}
export var ThreadMemberScope;
(function (ThreadMemberScope) {
    ThreadMemberScope["WRITE"] = "WRITE";
    ThreadMemberScope["ADMIN"] = "ADMIN";
})(ThreadMemberScope || (ThreadMemberScope = {}));
//# sourceMappingURL=messaging.interface.js.map